import { useRef, useState } from "react";
import { Button, Label, Spinner, Textarea, TextInput } from "flowbite-react";
import { EnvelopeIcon, UserIcon } from "../../components/icons/icons";
import MainLayout from "../../layout/MainLayout";
import {
  flowbiteCustomButtonThemeConfig,
  flowbiteCustomTextareaThemeConfig,
  flowbiteCustomTextInputThemeConfig,
} from "../../shared/flowbiteThemeConfig";
import emailjs from "emailjs-com";

function ContactPage() {
  const form = useRef<HTMLFormElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();

    if (form.current) {
      setIsLoading(true);

      const emailSubjectInput = form.current.querySelector(
        "input[name='email_subject']",
      ) as HTMLInputElement;
      if (emailSubjectInput && !emailSubjectInput.value) {
        emailSubjectInput.value = "no-subject";
      }

      emailjs
        .sendForm(
          process.env.REACT_APP_EMAILJS_SERVICE_ID, // EmailJS service ID
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // EmailJS template ID
          form.current,
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY, // EmailJS public key
        )
        .then(
          (result) => {
            console.log(result.text);
            alert("Email successfully sent!");
            setIsLoading(false);
            setIsSubmitted(true);
          },
          (error) => {
            console.log(error.text);
            alert("Failed to send email.");
            setIsLoading(false);
          },
        );
    }
  };

  const resetForm = () => {
    if (form.current) {
      form.current.reset();
      setIsSubmitted(false);
    }
  };

  return (
    <MainLayout>
      <form
        ref={form}
        onSubmit={sendEmail}
        autoComplete="off"
        className="mx-2 sm:mx-4 md:mx-auto lg:my-10 my-6 md:max-w-[36rem] bg-gray-600 bg-opacity-20 md:pt-16 md:pb-10 pt-8 pb-6 sm:pb-8 sm:pt-12 px-4 sm:px-12 rounded-2xl shadow-sm shadow-gray-700"
      >
        <h1 className="text-3xl text-center font-semibold">
          Contact me today!
        </h1>
        <div className="sm:flex lg:mt-10 mt-6">
          <div className="sm:w-[50%] sm:pe-2 mb-4">
            <div className="mb-2 block">
              <Label
                htmlFor="firstName"
                value="First name"
                className="text-gray-400"
              />
            </div>
            <TextInput
              theme={flowbiteCustomTextInputThemeConfig}
              color="custom"
              id="firstName"
              type="text"
              icon={UserIcon}
              placeholder="John"
              name="first_name"
              autoComplete="off"
              required
            />
          </div>
          <div className="sm:w-[50%] mb-4 sm:mb-0">
            <div className="mb-2 block">
              <Label
                htmlFor="lastName"
                value="Last name"
                className="text-gray-400"
              />
            </div>
            <TextInput
              theme={flowbiteCustomTextInputThemeConfig}
              color="custom"
              id="lastName"
              type="text"
              icon={UserIcon}
              placeholder="Doe"
              name="last_name"
              autoComplete="off"
              required
            />
          </div>
        </div>
        <div className="mb-4">
          <div className="mb-2 block">
            <Label
              htmlFor="email"
              value="Your email"
              className="text-gray-400"
            />
          </div>
          <TextInput
            theme={flowbiteCustomTextInputThemeConfig}
            color="custom"
            id="email"
            type="email"
            icon={EnvelopeIcon}
            placeholder="john.doe@email.com"
            name="email"
            autoComplete="off"
            required
          />
        </div>
        <div className="mb-4">
          <div className="mb-2 block">
            <Label
              htmlFor="emailSubject"
              value="Your email subject"
              className="text-gray-400"
            />
          </div>
          <TextInput
            theme={flowbiteCustomTextInputThemeConfig}
            color="custom"
            id="emailSubject"
            type="text"
            placeholder="Email Subject (optional)"
            name="email_subject"
            autoComplete="off"
          />
        </div>
        <div>
          <div className="mb-2 block">
            <Label
              htmlFor="comment"
              value="Your message"
              className="text-gray-400"
            />
          </div>
          <Textarea
            theme={flowbiteCustomTextareaThemeConfig}
            color="custom"
            id="comment"
            placeholder="Leave a comment..."
            rows={4}
            name="message"
            className="bg-gray-800 border-gray-700"
            required
          />
        </div>
        <div className="flex justify-center mt-4">
          <Button
            type="submit"
            theme={flowbiteCustomButtonThemeConfig}
            color="custom"
            disabled={isLoading}
          >
            <span>Submit</span>
            {isLoading && <Spinner className="ms-2" color="gray" size="sm" />}
          </Button>
          {isSubmitted && (
            <button
              type="button"
              className="text-sm ms-4 hover:text-cyan-300 hover:underline"
              onClick={resetForm}
            >
              Clear Form
            </button>
          )}
        </div>
      </form>
    </MainLayout>
  );
}

export default ContactPage;
